export default __webpack_public_path__ + "static/media/route_optimize.441ca0bc.svg";